module.exports = __webpack_public_path__ + "img/ko_arima2.f548c4e8.jpg";